module.exports = __webpack_public_path__ + "img/search-box.bbe280f5.png";